import { render, staticRenderFns } from "./phrase_add.vue?vue&type=template&id=56c6e67b&"
import script from "./phrase_add.vue?vue&type=script&lang=ts&"
export * from "./phrase_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports